import React, { useMemo, useState } from 'react'
import { useAdminNodeContext } from './admin-node-context'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { NodeItem } from './shared/node-item'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { Route, useHistory, useRouteMatch } from '../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { Filter } from '../../../../../shared/legacy/filter'
import { AdminNodeEdit } from './node-edit'
import { Menu, MenuAdd, MenuDelete, MenuEdit, MenuItem, MenuRecycle } from '../../../../../shared/menu/menu'
import { Delete } from '../../../../../shared/page/page-delete'
import { useApiFormNode } from '../../../../../api-new/state/content'
import { AssetList } from './asset-list'
import { NoChildren } from './shared/no-child-nodes'
import { NodeAdd } from './node-add'
import { NodeRecycle } from './node-recycle'
import { IconEnter } from '../../../../../shared/icon/icon'
import { IconList } from '../../../../../shared/icon/icon'

export const GridChild = () => {
  const { nodeID } = useParamsInt()
  const { url } = useRouteMatch()
  const history = useHistory()

  const adminNodeContext = useAdminNodeContext()

  const [nodeSearch, updateNodeSearch] = useState('')

  const nodes = useMemo(() => adminNodeContext.nodes.filter(i => i.parentID === nodeID), [adminNodeContext.nodes, nodeID])

  const filteredNodes = useMemo(
    () => {
      let lowerValue = nodeSearch.toLowerCase()
      if (nodeSearch) return nodes.filter(i => i.name.toLowerCase().includes(lowerValue))
      else return nodes
    },
    [nodes, nodeSearch]
  )

  const currentNode = useMemo(() => adminNodeContext.nodes.find(i => i.id === nodeID), [adminNodeContext.nodes, nodeID])
  const nodeName = useMemo(() => (currentNode ? currentNode.name : ''), [currentNode])

  const handleAdd = node => history.push(`${url}/node/${node.id}/edit`)
  const handleClick = node => history.push(`${url}/node/${node.id}`)
  const handleAssets = node => history.push(`${url}/node/${node.id}/assets`)
  const handleEdit = node => history.push(`${url}/node/${node.id}/edit`)
  const handleDelete = node => history.push(`${url}/node/${node.id}/delete`)
  const handleSuccessDelete = node => adminNodeContext.nodeRemove(node)

  const headerMenu = () =>
    <Menu>
      <MenuAdd to={`${url}/add/${nodeID}`} show />
      <MenuEdit to={`${url}/edit`} show />
      <MenuItem Icon={IconEnter} text="assets" to={`${url}/assets`} show />
      <MenuDelete to={`${url}/delete`} show />
      <MenuRecycle to={`${url}/recycle`} show />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text={nodeName}>
        <CardFullHeightScrollY title={nodeName} HeaderMenu={headerMenu}>
          <Filter value={nodeSearch} onChange={updateNodeSearch} />
          <div className="row g-2 m-2">
            {filteredNodes
              .sort((a, b) => (a.name < b.name ? -1 : 1))
              .map((node, i) =>
                <NodeItem key={i} node={node} onClick={handleClick} onAssets={handleAssets} onEdit={handleEdit} onDelete={handleDelete} />
              )}

            <NoChildren nodes={nodes} />
          </div>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/add/:parentID`} component={NodeAdd}>
        <NodeAdd onAdd={handleAdd} />
      </Route>

      <Route path={`${url}/node/:nodeID`} component={GridChild} />
      <Route path={`${url}/node/:nodeID/assets`} component={AssetList} />

      <Route path={`${url}/node/:nodeID/edit`}>
        <AdminNodeEdit onChildren={handleClick} onAssets={handleAssets} onDelete={handleDelete} />
      </Route>

      <Route path={`${url}/node/:deleteID/delete`}>
        <Delete useApiForm={useApiFormNode} titleParam="name" successPath={`${url}`} onSuccess={handleSuccessDelete} />
      </Route>

      <Route path={`${url}/recycle`} component={NodeRecycle} />
    </React.Fragment>
  )
}
